export const PROMPT_SECTION_CATEGORIES = [
  'mortgage',
  'subsidio',
  'normativa',
  'flows',
  'multiagente',
  'agendamiento',
  'generales',
  'prompt_base',
  'advisor_prompt',
  'brokerage_prompt',
  'tools',
  'utils',
  'chile',
  'peru',
  'argentina',
  'otros_paises',
  'deprecado',
  'otros',
] as const;

export type PromptSectionCategory = (typeof PROMPT_SECTION_CATEGORIES)[number];

export interface PromptSectionCategoryMeta {
  value: PromptSectionCategory;
  text: string;
  chip: string;
}

/**
 * Single source of truth for global prompt-section categories. Keys mirror the backend
 * `globalPromptSectionCategories` list in `apps/lidz_back/src/models/GlobalPromptSectionCategory.ts`.
 */
export const PROMPT_SECTION_CATEGORY_META: Record<PromptSectionCategory, PromptSectionCategoryMeta> = {
  mortgage: { value: 'mortgage', text: 'Hipotecario', chip: 'bg-blue-50 text-blue-700' },
  subsidio: { value: 'subsidio', text: 'Subsidio', chip: 'bg-green-50 text-green-700' },
  normativa: { value: 'normativa', text: 'Normativa', chip: 'bg-purple-50 text-purple-700' },
  flows: { value: 'flows', text: 'Flows', chip: 'bg-cyan-50 text-cyan-700' },
  multiagente: { value: 'multiagente', text: 'Multiagente', chip: 'bg-orange-50 text-orange-700' },
  agendamiento: { value: 'agendamiento', text: 'Agendamiento', chip: 'bg-pink-50 text-pink-700' },
  generales: { value: 'generales', text: 'Generales', chip: 'bg-slate-100 text-slate-700' },
  prompt_base: { value: 'prompt_base', text: 'Prompt base', chip: 'bg-violet-50 text-violet-700' },
  advisor_prompt: { value: 'advisor_prompt', text: 'Advisor prompt', chip: 'bg-indigo-50 text-indigo-700' },
  brokerage_prompt: { value: 'brokerage_prompt', text: 'Brokerage prompt', chip: 'bg-teal-50 text-teal-700' },
  tools: { value: 'tools', text: 'Tools', chip: 'bg-stone-100 text-stone-700' },
  utils: { value: 'utils', text: 'Utils', chip: 'bg-yellow-50 text-yellow-800' },
  chile: { value: 'chile', text: 'Chile', chip: 'bg-red-50 text-red-700' },
  peru: { value: 'peru', text: 'Perú', chip: 'border border-gray-300 bg-white text-gray-600' },
  argentina: { value: 'argentina', text: 'Argentina', chip: 'bg-sky-50 text-sky-700' },
  otros_paises: { value: 'otros_paises', text: 'Otros países', chip: 'bg-slate-200 text-slate-800' },
  deprecado: { value: 'deprecado', text: 'Deprecado', chip: 'bg-gray-100 text-gray-600' },
  otros: { value: 'otros', text: 'Otros', chip: 'bg-gray-50 text-gray-500' },
};
